import { render, staticRenderFns } from "./PerformanceList.vue?vue&type=template&id=03a4244c"
import script from "./PerformanceList.vue?vue&type=script&lang=js"
export * from "./PerformanceList.vue?vue&type=script&lang=js"
import style0 from "./PerformanceList.vue?vue&type=style&index=0&id=03a4244c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports